import { combineReducers } from 'redux';
import externalCallsFilters from 'store/reducers/external-api-call-log/get-external-calls-filters';
import getExternalCalls from 'store/reducers/external-api-call-log/get-external-calls';
import externalCallsTableFilters from 'store/reducers/external-api-call-log/get-external-calls-table-filters';

export default combineReducers({
  externalCallsFilters,
  getExternalCalls,
  externalCallsTableFilters,
});